import React, { useState } from 'react';
import { Table } from 'antd';
import { Tag } from 'ui';
import { useT } from 'hooks/Locale/useT';
import { NavLink } from 'react-router-dom';
import { TagStatus } from 'ui/Tag/types';
import CommentModal from '../Modals/CommentModal';
import { FormattedMessage } from 'react-intl';
import generalHelpers from 'utils/generalHelpers';

interface LearningTestTableInterface {
    data: any[];
}

const LearningTestTable: React.FC<LearningTestTableInterface> = ({ data }) => {
    const t = useT();
    const [showCommentModal, setShowCommentModal] = useState<any>([]);

    const columns = [
        {
            title: t('program.test_attempt'),
            render: (_text: string, record: any) =>
                t('program.test_attempt_count', { attempt: record.attempt }),
        },
        {
            title: t('student.result'),
            dataIndex: 'resultStr',
            render: (resultStr: string) => generalHelpers.normalizePercent(resultStr),
        },
        {
            title: t('general.status'),
            dataIndex: 'status',
            render: (status: TagStatus) => (status ? <Tag status={status} /> : null),
        },
        {
            title: t('program.attempt_start'),
            dataIndex: 'attemptStart',
        },
        {
            title: t('program.attempt_end'),
            dataIndex: 'attemptEnd',
        },
        {
            title: t('program.total_time_spent'),
            dataIndex: 'timeSpent',
            render: (time: number) => (time ? generalHelpers.toHoursAndMinutes(time) : '-'),
        },
        {
            title: t('program.result_comment'),
            render: (_text: string, record: any) => (
                <div
                    className={'pointer'}
                    onClick={() => (record?.comment ? setShowCommentModal(record.comment) : null)}
                >
                    <i className="fa-sharp fa-regular fa-comment-check"></i>
                </div>
            ),
        },
        {
            title: t('general.overview'),
            dataIndex: 'attemptId',
            key: 'overview',
            render: (attemptId: number, record: any) => {
                if (record.status === 'IN_PROGRESS') {
                    return '-';
                } else {
                    return (
                        <NavLink to={`/learning/tests/${attemptId}/overview`} target="_blank">
                            <FormattedMessage id="learning_tests.overview" />
                        </NavLink>
                    );
                }
            },
        },
    ];

    return (
        <>
            <Table
                columns={columns}
                dataSource={data}
                rowKey={'id'}
                pagination={{ position: [] }}
            />
            <CommentModal open={showCommentModal} onCancel={setShowCommentModal} />
        </>
    );
};

export default LearningTestTable;
